import React from 'react';
import { motion } from 'framer-motion';
function GoldCheck() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="flex-shrink-0" data-id="element-138">
      <path d="M20 6L9 17L4 12" stroke="#C9952A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-139" />
    </svg>;
}
const MOBILE_BG = 'https://cdn.magicpatterns.com/uploads/fCvdnhduCkw5v2iFC5uAxV/BANER_PV_1X1.png';
const DESKTOP_BG = 'https://cdn.magicpatterns.com/uploads/ceSKWkGqHWguWtqxDKAH2r/BANNER_PV_2.png';
interface HeroProps {
  language: 'en' | 'es';
}
export function Hero({
  language
}: HeroProps) {
  const t = {
    en: {
      label: '▸ WEST TEXAS PORTABLE RESTROOM & TRAILER RENTALS',
      headlineMobile1: 'YOUR JOB SITE.',
      headlineMobile2: 'YOUR PROJECT.',
      headlineMobile3: 'YOUR EVENT.',
      headlineMobile4: 'COVERED.',
      headlineDesktop1: 'YOUR JOB SITE. YOUR PROJECT.',
      headlineDesktop2: 'YOUR EVENT. COVERED.',
      subMobile1: 'Clean units, on-time delivery, and',
      subMobile2: 'fast service across West Texas.',
      subDesktop: 'Clean units, on-time delivery, and fast service across West Texas.',
      quoteBtn: 'GET YOUR FREE QUOTE →',
      call1: 'CALL: 432-528-7892',
      call2: 'CALL: 432-803-4737',
      trust1: 'Clean & Sanitized',
      trust2: 'On-Time Delivery',
      trust3: 'Oilfield & Event Ready',
      trust4: 'Locally Owned'
    },
    es: {
      label: '▸ RENTA DE BAÑOS PORTÁTILES Y REMOLQUES EN WEST TEXAS',
      headlineMobile1: 'TU OBRA.',
      headlineMobile2: 'TU PROYECTO.',
      headlineMobile3: 'TU EVENTO.',
      headlineMobile4: 'CUBIERTO.',
      headlineDesktop1: 'TU OBRA. TU PROYECTO.',
      headlineDesktop2: 'TU EVENTO. CUBIERTO.',
      subMobile1: 'Unidades limpias, entrega a tiempo y',
      subMobile2: 'servicio rápido en todo West Texas.',
      subDesktop: 'Unidades limpias, entrega a tiempo y servicio rápido en todo West Texas.',
      quoteBtn: 'OBTÉN TU COTIZACIÓN GRATIS →',
      call1: 'LLAMAR: 432-528-7892',
      call2: 'LLAMAR: 432-803-4737',
      trust1: 'Limpio y Desinfectado',
      trust2: 'Entrega a Tiempo',
      trust3: 'Listo para Obra y Eventos',
      trust4: 'Empresa Local'
    }
  };
  const text = t[language];
  return <section id="home" className="relative min-h-[85svh] md:h-screen flex flex-col items-center justify-center w-full overflow-hidden" data-id="element-140">
      {/* Mobile Background */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat bg-scroll md:hidden" style={{
      backgroundImage: `url("${MOBILE_BG}")`
    }} data-id="element-141">
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.50) 50%, rgba(0,0,0,0.70) 100%)'
      }} data-id="element-142"></div>
      </div>

      {/* Desktop Background */}
      <div className="absolute inset-0 z-0 bg-cover bg-bottom bg-no-repeat hidden md:block" style={{
      backgroundImage: `url("${DESKTOP_BG}")`
    }} data-id="element-143">
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.50) 50%, rgba(0,0,0,0.70) 100%)'
      }} data-id="element-144"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center" data-id="element-146">
          {/* Label */}
          <span className="font-montserrat text-gold font-bold uppercase block mb-3 md:mb-4 px-6 md:px-0 leading-[1.4] text-[10px] tracking-[1.5px] md:text-sm md:tracking-[2px]" data-id="element-147">
            {text.label}
          </span>

          {/* Headline - Mobile */}
          <h1 className="md:hidden font-oswald font-bold text-warmWhite text-center px-3 mb-4" style={{
          fontSize: 'clamp(2.4rem, 9vw, 3.2rem)',
          lineHeight: '1.05',
          letterSpacing: '-0.5px',
          textShadow: '0 2px 20px rgba(0,0,0,0.9), 0 0 40px rgba(0,0,0,0.8)',
          wordBreak: 'keep-all',
          hyphens: 'none' as const
        }} data-id="element-148">
            {text.headlineMobile1}
            <br data-id="element-149" />
            {text.headlineMobile2}
            <br data-id="element-150" />
            {text.headlineMobile3}
            <br data-id="element-151" />
            {text.headlineMobile4}
          </h1>

          {/* Headline - Desktop */}
          <h1 className="hidden md:block font-oswald font-bold text-warmWhite leading-[1.1] mb-6" style={{
          fontSize: 'clamp(3rem, 5vw, 4.5rem)',
          textShadow: '0 2px 20px rgba(0,0,0,0.9), 0 0 40px rgba(0,0,0,0.8)'
        }} data-id="element-152">
            {text.headlineDesktop1}
            <br data-id="element-153" />
            {text.headlineDesktop2}
          </h1>

          {/* Subheadline */}
          <h2 className="font-inter font-semibold text-warmWhite mb-8 md:mb-10 max-w-2xl mx-auto" style={{
          textShadow: '0 2px 12px rgba(0,0,0,0.9)'
        }} data-id="element-154">
            <span className="md:hidden text-[1.15rem] leading-relaxed" data-id="element-155">
              {text.subMobile1}
              <br data-id="element-156" />
              {text.subMobile2}
            </span>
            <span className="hidden md:inline text-xl lg:text-2xl" data-id="element-157">
              {text.subDesktop}
            </span>
          </h2>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 md:mb-12 justify-center items-center max-w-[340px] sm:max-w-none mx-auto" data-id="element-158">
            <a href="#quote" className="w-full sm:w-auto bg-gold text-obsidian px-8 py-4 md:py-5 rounded font-montserrat font-extrabold text-[16px] tracking-wide text-center hover:bg-yellow-500 hover:scale-105 transition-all duration-300" data-id="element-159">
              {text.quoteBtn}
            </a>
            <a href="tel:+14325287892" className="w-full sm:w-auto bg-transparent border-2 border-warmWhite text-warmWhite px-8 py-4 md:py-5 rounded font-montserrat font-bold text-[16px] tracking-wide text-center hover:border-gold hover:text-gold transition-all duration-300" data-id="element-160">
              {text.call1}
            </a>
            <a href="tel:+14328034737" className="w-full sm:w-auto bg-transparent border-2 border-warmWhite text-warmWhite px-8 py-4 md:py-5 rounded font-montserrat font-bold text-[16px] tracking-wide text-center hover:border-gold hover:text-gold transition-all duration-300" data-id="element-161">
              {text.call2}
            </a>
          </div>

          {/* Trust Items */}
          <div className="grid grid-cols-2 md:flex md:flex-row md:justify-center gap-2 md:gap-6 px-4 md:px-0 pb-6 md:pb-0 font-inter text-xs md:text-sm text-warmWhite relative z-10" data-id="element-162">
            <span className="flex items-center justify-center gap-2 bg-black/60 md:bg-transparent border border-gold/40 md:border-0 rounded-md py-2 px-3 md:p-0 text-center" data-id="element-163">
              <GoldCheck data-id="element-164" /> {text.trust1}
            </span>
            <span className="flex items-center justify-center gap-2 bg-black/60 md:bg-transparent border border-gold/40 md:border-0 rounded-md py-2 px-3 md:p-0 text-center" data-id="element-165">
              <GoldCheck data-id="element-166" /> {text.trust2}
            </span>
            <span className="flex items-center justify-center gap-2 bg-black/60 md:bg-transparent border border-gold/40 md:border-0 rounded-md py-2 px-3 md:p-0 text-center" data-id="element-167">
              <GoldCheck data-id="element-168" /> {text.trust3}
            </span>
            <span className="flex items-center justify-center gap-2 bg-black/60 md:bg-transparent border border-gold/40 md:border-0 rounded-md py-2 px-3 md:p-0 text-center" data-id="element-169">
              <GoldCheck data-id="element-170" /> {text.trust4}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}